import { useEffect } from 'react';
import { FieldErrors, UseFormSetError } from 'react-hook-form';
import { translateKey } from 'src/locales/translate';
import {
  WarehouseErrorCode,
  warehouseErrorCode,
} from 'src/sections/@dashboard/warehouse/utils/errors';
import { MedicationsFormModalValuesProps } from './medicationFormSchema';

type RefusedField = 'stockRecipientAddress' | 'stockPrescription';

/** The "Magazyn" field a handed-over Rx drug's refusal names. */
const REFUSED_FIELDS: Partial<Record<WarehouseErrorCode, RefusedField>> = {
  RECIPIENT_ADDRESS_REQUIRED: 'stockRecipientAddress',
  PRESCRIPTION_FACTS_REQUIRED: 'stockPrescription',
};

/**
 * #688 R1-2: a save refused with 422 RECIPIENT_ADDRESS_REQUIRED (a guest or
 * an owner without a profile address) shows its message on "Adres odbiorcy"
 * and brings the vet to that step; PRESCRIPTION_FACTS_REQUIRED does the same
 * on the prescription. The host's snackbar says it too.
 */
export function useStockRefusalField(
  refusal: unknown,
  setError: UseFormSetError<MedicationsFormModalValuesProps>,
  goToFirstError: (
    errors: FieldErrors<MedicationsFormModalValuesProps>,
  ) => void,
): void {
  useEffect(() => {
    const code = warehouseErrorCode(refusal);
    const field = code && REFUSED_FIELDS[code];
    if (!code || !field) return;
    const error = {
      type: 'server',
      message: translateKey(`warehouse.errors.${code}`),
    };
    setError(field, error);
    goToFirstError({ [field]: error });
    // Once per refusal: the host hands a new error object for every answer.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refusal]);
}
